module.exports = __webpack_public_path__ + "img/youtube-icon.e8998475.svg";